import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const appearCentered = keyframes`
  0% {
    background-color: transparent;
    transform: translate(-50%, -50%) scale(0);
  }
  100% {
    background-color: var(--outline);
    transform: translate(-50%, -50%) scale(1);
  }
`;

const pulseCentered = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
`;

export const StyledButton = styled.button<{ inline?: boolean }>`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: ${({ inline }) => (inline ? '24px' : '40px')};
  height: ${({ inline }) => (inline ? '24px' : '40px')};
  border-radius: 50%;
  background: transparent;
  cursor: pointer;

  ::before {
    content: '';
    position: absolute;
    width: 40px;
    height: 40px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: inherit;
    transition: background-color 0.1s ease-in-out;
  }

  :hover::before {
    background: var(--state-hover-on-surface);
  }

  :active::before {
    background: var(--state-active-on-surface);
  }

  :focus::before {
    animation:
      ${appearCentered} ease-in-out 0.2s forwards,
      ${pulseCentered} 1.5s 0.2s ease-in-out infinite;
  }
`;
